<template>
  <!-- 采购单详情 -->
  <div class="addPerson__wrap" v-show="visible" style="z-index: 10 !important">
    <el-header class="shadow page-header__wrap">
      <div class="flex">
        <div class="backBtn" @click="handleReturn">
          <el-image
            class="back-img"
            :src="require('@/assets/img/back.png')"
          ></el-image>
          <span>返回</span>
        </div>
        <div class="title">
          <span class="site">当前位置：</span>
          {{ $route.meta.title }}
          <span> > </span>
          采购单详情
        </div>
      </div>
    </el-header>

    <div class="main">
      <div class="mainBox">
        <div class="itemTime">基础信息</div>
        <el-descriptions title="">
          <el-descriptions-item label="采购来源">
            <span>{{ info.source == 1 ? "销售订单" : "平台自采" }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="计划交货日期">{{
            info.delivery_date
          }}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{
            info.create_time
          }}</el-descriptions-item>
          <el-descriptions-item label="采购单号">{{
            info.order_no
          }}</el-descriptions-item>
          <el-descriptions-item label="采购状态">{{
            toStr(
              {
                0: "待发货",
                1: "待收货",
                2: "已取消",
                3: "部分收货",
                4: "全部收货",
              },
              info.status
            )
          }}</el-descriptions-item>
          <!-- 订单 4 是全部收货  明细 5是全部收货 -->
          <el-descriptions-item label="创建人">{{
            info.admin_name
          }}</el-descriptions-item>
          <el-descriptions-item label="地区">{{
            info.city_name
          }}</el-descriptions-item>
          <el-descriptions-item label="仓库名称" v-if="!!info.stash_name"
            >{{ info.stash_name }}（{{ info.stash_province
            }}{{ info.stash_city }}）</el-descriptions-item
          >
          <el-descriptions-item
            label="收货人"
            v-if="info.status != 2 && info.delivery_num > 0"
            >{{ info.delivery_name }}</el-descriptions-item
          >
          <el-descriptions-item
            label="供应商/采购员"
            v-if="!!info.supplier_name"
            >{{ info.supplier_name }}</el-descriptions-item
          >
          <el-descriptions-item label="发货时间" v-if="!!info.send_time">{{
            info.send_time
          }}</el-descriptions-item>
          <!-- 已关闭的不展示已记账数量和已记账数量 -->
          <el-descriptions-item
            label="已记账数量"
            v-if="info.status != 2 && info.delivery_num > 0"
            >{{ info.delivery_num }}</el-descriptions-item
          >
          <el-descriptions-item
            label="已记账金额"
            v-if="info.status != 2 && info.delivery_money > 0"
            >￥{{ info.delivery_money }}</el-descriptions-item
          >
          <el-descriptions-item label="完成时间" v-if="info.status == 4">{{
            info.complete_time
          }}</el-descriptions-item>
          <el-descriptions-item label="关闭时间" v-if="info.status == 2">{{
            info.cancel_time
          }}</el-descriptions-item>
          <el-descriptions-item label="录单人">{{
            info.delivery_name
          }}</el-descriptions-item>
        </el-descriptions>

        <div class="itemTime">
          收货<span style="color: #999; font-size: 14px">
            (共{{ table.total }}项)</span
          >
        </div>
        <el-input
          style="width: 240px; margin-bottom: 10px"
          v-model.trim="form.data.goods_name"
          placeholder="请输入商品名称"
          size="small"
          clearable
          @clear="getTable"
          @keydown.enter.native="getTable"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="getTable"
          ></el-button>
        </el-input>
        <!-- is_sorter:1：是， 若供应商是支持代分拣的收货登记增加了食堂名称字段 -->
        <el-select
          v-if="info.is_sorter == 1"
          v-model="form.data.address_id"
          filterable
          :placeholder="`请输入${userId == 5 ? '用户' : '食堂'}名称`"
          style="width: 240px; margin-bottom: 10px; margin: 0 10px"
          clearable
          size="small"
          @focus="getStore"
          @change="getTable"
        >
          <el-option
            v-for="item in storeArr"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
            <span style="float: left">{{ item.name }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px"
              >({{ item.merchant_name }})</span
            >
          </el-option>
        </el-select>
        <el-button
          v-if="canPrint"
          style="margin-left: 10px"
          :size="subUnitSize"
          type="primary"
          plain
          @click="batchPrint"
          >批量打印</el-button
        >
        <el-button v-if="showUploadBill" plain type="primary" size="small" style="float: right;" @click="handleBill">上传单据</el-button>
        <el-table
          :data="tableData"
          style="width: 100%"
          :cell-style="{ background: '#fff' }"
          :span-method="objectSpanMethod2"
          @selection-change="handleSelectionChangeDetails"
          border
          ref="multipleTable"
        >
          <el-table-column type="selection" fixed></el-table-column>
          <el-table-column type="index" label="ID" fixed></el-table-column>
          <!-- 不支持分拣的供应商数据，不需要显示食堂名称字段 （来源销售订单也要展示食堂） -->
          <el-table-column
            v-if="info.is_sorter == 1"
            prop="store_name"
            label="食堂名称"
            fixed
            width="160px"
            key="6"
          >
          </el-table-column>
          <el-table-column
              prop="norm_name"
              label="标准名称"
              width="180px"
              fixed
              >
              <template slot-scope="{row}">
                <div>{{row.norm_name}}</div>
                <div>{{row.order_cate_name}}</div>
              </template>
            </el-table-column>
          <el-table-column
            prop="good_img"
            label="商品名称"
            width="180px"
            fixed
            key="1"
          >
            <template slot-scope="{ row }">
              <div style="display: flex; align-items: center">
                <el-image
                  v-if="!!row.goods_image"
                  style="width: 40px; height: 40px"
                  :src="row.goods_image"
                  fit="cover"
                  :preview-src-list="[row.goods_image]"
                ></el-image>
                <el-image
                  v-else
                  style="width: 40px; height: 30px"
                  :src="require('@/assets/img/logo-icon.jpeg')"
                  fit="cover"
                  :preview-src-list="[require('@/assets/img/logo-icon.jpeg')]"
                ></el-image>
                <span style="margin-left: 10px">{{ row.goods_name }}</span>
              </div>
              <div>{{row.code}}</div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="code" label="商品编码" width="120px" key="2">
          </el-table-column> -->
          <!-- <el-table-column
            prop="order_cate_name"
            label="下单分类"
            key="3"
            min-width="120px"
          >
            <template slot-scope="{ row }">
              <span>{{ row.order_cate_name }}</span>
              <span v-if="!!row.order_tow_name">
                / {{ row.order_tow_name }}</span
              >
            </template>
          </el-table-column> -->
          <el-table-column prop="unit_name" label="单位" key="4">
          </el-table-column>
          <el-table-column prop="spec_name" label="规格" key="5">
          </el-table-column>
          <el-table-column prop="price" label="售价" v-if="info.is_sorter == 1">
            <template slot-scope="{ row }">
              ￥{{row.price}}
            </template>
          </el-table-column>
          <el-table-column prop="avg_price" label="平均售价" v-if="info.is_sorter == 2">
            <template slot-scope="{ row }">
              ￥{{row.avg_price}}
            </template>
          </el-table-column>
          <el-table-column prop="num" label="下单数量" width="120px" key="12">
            <template slot-scope="{ row }">
              <span>{{row.num}}{{row.unit_name}}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="accept_type"
              label="验收状态"
              key="896">
              <template slot-scope="{row}">{{toStr({0:'未验收', 1:'部分验收', 2:'全部验收'},row.accept_type)}}</template>
            </el-table-column>
          <el-table-column
              prop="accept_num"
              label="验收数量"
              key="748">
              <template slot-scope="{row}">
                <span>{{row.accept_num}}{{row.accept_unit}}</span>
                <span v-if="row.accept_cov_times != 0 && row.accept_unit != row.accept_cov_unit">（{{row.accept_cov_num}}{{row.accept_cov_unit}}）</span>
              </template>
            </el-table-column>
          <el-table-column
            prop="last_purchase_price"
            label="采购价"
            width="120px"
            key="9"
          >
            <template slot-scope="{ row, $index }">
              <!-- 全部收货时可编辑采购价 -->
              <template v-if="info.status == 4 && row.isEdit == true">
                <el-input
                  v-model="row.last_purchase_price"
                  placeholder="请输入"
                  size="small"
                  :disabled="(row.cov_unit == row.unit_name || !row.cov_unit) && row.is_lock == 1"
                  @input="countPrice(row, $index)"
                ></el-input>
                <el-popconfirm
                    v-if="(row.cov_unit == row.unit_name || !row.cov_unit) && row.is_lock == 1 && Number(row.last_purchase_price) != Number(row.lock_amount)"
                    @confirm="editReceive(row,$index)"
                    title="确认更新为最新锁价金额吗？"
                  >
                  <div slot="reference" style="cursor: pointer;color:#409eff;text-align:center">更新锁价</div>
                </el-popconfirm>
              </template>
              <span v-else>
                {{row.last_purchase_price}}
                  <span v-if="row.last_purchase_price&&row.cov_unit?row.cov_unit:row.last_purchase_price?row.unit_name:''">/</span>
                {{row.last_purchase_price&&row.cov_unit?row.cov_unit:row.last_purchase_price?row.unit_name:''}}
              </span>
              <div
                v-if="
                  row.extent_curr != 0 &&
                  row.old_purchase_price != 0 &&
                  row.isEdit == false
                "
                style="display: inline"
              >
                <i
                  :class="
                    row.extent_curr > 0
                      ? 'el-icon-top redColor'
                      : 'el-icon-bottom greenColor'
                  "
                ></i>
                <span
                  :class="
                    row.extent_curr > 0
                      ? 'extent redColor'
                      : 'extent greenColor'
                  "
                  >{{ Math.abs(row.extent_curr) }}</span
                >
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="cov_unit"
            label="采购单位"
            width="110px"
            key="10"
          >
            <template slot-scope="{ row }">
              没有采购单位就默认下单单位
              <span>{{ !!row.cov_unit ? row.cov_unit : row.unit_name }}</span>
              如果有单位转化就显示转化
              <span v-if="row.cov_times != 0"
                >（{{ row.cov_times }}{{ row.unit_name }}）</span
              >
            </template>
          </el-table-column> -->
          <el-table-column
            prop="delivery_num"
            label="已记账数量"
            width="100px"
            key="13"
          >
            <template slot-scope="{ row, $index }">
              <el-input
                v-if="info.status == 4 && row.isEdit == true"
                v-model="row.delivery_num"
                placeholder="请输入"
                size="small"
                @input="countPrice(row, $index)"
              ></el-input>
              <span v-else>
                {{row.cov_unit?row.delivery_num+row.unit_name+'('+row.cov_num+row.cov_unit+')' : row.delivery_num+row.unit_name }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="delivery_money"
            label="记账金额"
            width="120px"
            key="14"
          >
            <template slot-scope="{ row }">
              <el-input
                v-if="info.status == 4 && row.isEdit == true"
                v-model="row.delivery_money"
                placeholder="请输入"
                size="small"
                @input="
                  row.delivery_money = row.delivery_money.replace(/[^\d.]/g, '')
                "
              ></el-input>
              <span v-else>{{ row.delivery_money }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" width="180px" key="15">
            <template slot-scope="{ row }">
              <div v-for="(v, i) in row.remark" :key="i">{{ v }}。</div>
            </template>
          </el-table-column>
          <el-table-column prop="refund_num" label="退货数" key="16">
            <template slot-scope="{ row }">
              <el-link
                v-if="row.refund_num > 0"
                type="primary"
                @click="handleRefund(row)"
                >{{ row.refund_num }} <i class="el-icon-view"></i
              ></el-link>
            </template>
          </el-table-column>
          <!-- 全部收货状态才有操作 -->
          <el-table-column
            prop="action"
            :width="info.status == 4 ? '140px' : '80px'"
            fixed="right"
            label="操作"
            key="17"
          >
            <template slot-scope="{ row, $index }">
              <template v-if="info.status == 4">
                <el-button
                  type="text"
                  @click="confirm(row, $index)"
                  :icon="row.isEdit == false ? 'el-icon-edit' : ''"
                  >{{ row.isEdit == false ? "编辑" : "保存" }}</el-button
                >
              </template>
              <el-button v-if="canPrint" type="text" @click="handlePrint(row)"
                >打印标签</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <template v-if="billArr.length > 0">
            <div class="itemTime">采购单据</div>
            <div class="mt20" v-for="(item,index) in billArr" :key="index">
              <div>
                <span class="name">{{item.name}} </span>
                <span class="time">{{item.create_time}} </span>
              </div>
              <div style="display:flex">
                <div v-for="(img,imgIndex) in item.bills" :key="img" style="margin-top:10px;margin-right:10px;display: flex;flex-direction: column;align-items: center;">
                  <el-image
                    style="width: 60px; height: 60px;"
                    :src="img" 
                    :preview-src-list="[img]">
                  </el-image>
                  <el-popconfirm
                    v-if="showDeleteBill"
                    title="确定删除单据吗？"
                    placement="right-start"
                    @confirm="deleteBillRow(item,imgIndex)"
                  >
                    <el-button slot="reference" type="text">删除</el-button>
                  </el-popconfirm>
                </div>
              </div>
            </div>
          </template>
      </div>
      <!-- currRow.showType !== 9999,从入库列表、采购汇总查看的采购单详情不需要操作 -->
      <div class="footerWrap" v-if="currRow.showType !== 9999">
        <!-- status 0:'待发货' 1:'待收货', 2:'已关闭', 3:'部分收货', 4:'全部收货'  -->
        <!-- this.info.status == 0 ||  -->
        <el-button
          v-if="currRow.accept_status != 2"
          type="primary"
          plain
          size="medium"
          @click="handleCancel"
          >关闭</el-button
        >
        <el-button
          v-if="
            this.info.status == 0 ||
            this.info.status == 1 ||
            this.info.status == 3
          "
          type="primary"
          plain
          size="medium"
          @click="handleReceive"
          >收货</el-button
        >
        <el-button
          v-if="this.info.status != 2"
          type="primary"
          plain
          size="medium"
          @click="plexportDataGoods"
          >导出</el-button
        >
        <el-button type="primary" plain size="medium" @click="handleCopy"
          >复制</el-button
        >
      </div>
    </div>

    <el-dialog
      title="退货详情"
      width="500px"
      append-to-body
      :visible.sync="dialogTableVisible"
      center
      :close-on-click-modal="false"
    >
      <el-descriptions class="margin-top" title="" :column="1" border>
        <el-descriptions-item label="商品名称" :labelStyle="labelStyle">
          <div>{{ refundInfo.goods_name }}</div>
          <div style="color: #999; font-size: 12px">{{ refundInfo.code }}</div>
        </el-descriptions-item>
        <el-descriptions-item label="采购价" :labelStyle="labelStyle"
          >¥{{ refundInfo.true_purchase_price }}/{{
            refundInfo.unit_name
          }}</el-descriptions-item
        >
        <!-- 原记账数量 = 记账数量delivery_num + 退货数量refund_num-->
        <el-descriptions-item label="原记账数量" :labelStyle="labelStyle"
          >{{
            Number(refundInfo.delivery_num) + Number(refundInfo.refund_num)
          }}{{ refundInfo.unit_name }}</el-descriptions-item
        >
        <el-descriptions-item label="退货数量" :labelStyle="labelStyle"
          >{{ refundInfo.refund_num }}{{
            refundInfo.unit_name
          }}</el-descriptions-item
        >
        <el-descriptions-item label="退货金额" :labelStyle="labelStyle"
          >¥{{ refundInfo.refund_money }}</el-descriptions-item
        >
        <el-descriptions-item label="退货原因" :labelStyle="labelStyle">{{
          toStr(
            { 1: "质量问题", 2: "买多了/买错了", 3: "商品与要求不符" },
            refundInfo.refund_reason
          )
        }}</el-descriptions-item>
        <el-descriptions-item label="创建时间" :labelStyle="labelStyle">{{
          refundInfo.refund_time
        }}</el-descriptions-item>
        <el-descriptions-item label="创建人" :labelStyle="labelStyle">{{
          refundInfo.refund_name
        }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <!-- 批量打印提示弹窗 -->
    <el-dialog
      title="确认打印标签吗？"
      :visible.sync="dialogVisiblePrint"
      width="450px"
      :before-close="handleClosePrint"
      center
      append-to-body
    >
      <template>
        <div style="margin-bottom: 10px">
          采购单号：<span style="font-weight: bold">{{ info.order_no }}</span>
        </div>
        <div>
          标签数量：
          <span style="font-weight: bold">{{ batchPrintData.length }}</span>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          v-print="'myPrintBatchDetails'"
          @click="handlePrintbatchFun"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 批量打印区域 -->
    <div id="myPrintBatchDetails" ref="myPrintBatchDetails">
      <div
        class="printContent"
        style="padding: 4px 20px"
        v-for="(item, index) in batchPrintData"
        :key="index"
      >
        <div class="print-title" style="margin-top: 4px">
          {{ item.supplier_name }}
        </div>
        <div class="print-flex">
          <div class="print-flex-main">
            <div class="print-con">
              <div>{{ item.goods_name }}</div>
              <div class="print-text">{{ item.spec_name }}</div>
            </div>
            <div class="print-con">
              下单数量：{{ item.num }}{{ item.unit_name }}
            </div>
            <div class="print-con">
              记账数量：{{ getdelivery_num(item)
              }}{{
                getdelivery_num(item) || getdelivery_num(item) === 0
                  ? item.unit_name
                  : ""
              }}
              {{
                Number(item.cov_times)
                  ? `${(item.delivery_num / item.cov_times).toFixed(2)}(${
                      item.cov_unit
                    })`
                  : ""
              }}
            </div>
          </div>
          <div>
            <div class="qrcode" ref="qrCodeUreBatchDetails"></div>
          </div>
        </div>
        <div
          class="print-text"
          style="text-align: right; margin-top: 2px; margin-bottom: 2px"
        >
          {{ $moment(new Date()).format("yyyy-MM-DD HH:mm:ss") }}
        </div>
      </div>
    </div>
    <!-- 上传单据 -->
      <el-dialog
        title=""
        :visible.sync="dialogVisibleBill"
        width="400px"
        :before-close="handleClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
        center>
        <el-form
          class="staff-from"
          v-loading="formBill.loading"
          element-loading-text="加载中…"
          ref='elFormDomBill'
          label-width='110px'
          label-position='top'
          :model='formBill.data'
          :rules='formBill.rules'
          :size="subUnitSize"
          max-height="600px"
        >
          <el-form-item label="上传单据(最多10张)" prop="bills">
            <el-upload
              action="/api/common/qiniu/upload"
              :limit="10"
              list-type="picture-card"
              class="imgWrap"
              ref="upload"
              multiple
              :headers="{ token: token }"
              :on-preview="handlePictureCardPreview"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
              :on-remove="handleRemove2"
              :file-list="fileList"
              :on-exceed="handleExceed"
              :http-request="uploadFile"
              accept="image/jpeg, image/png, image/gif"
              :auto-upload="true"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisibleUrl" append-to-body>
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-row type="flex" justify="center">
            <el-button type="primary" :loading="formBill.loading" @click="sumbitBill">确定</el-button>
          </el-row>
        </template>
      </el-dialog>
  </div>
</template>

<script>
import { getStorage } from "@/storage";
import { mixinTable } from "@/mixins/table.js";
import { v4 as uuid } from "uuid";
import QRCode from "qrcodejs2";
export default {
  name: "purchaseDetail",
  mixins: [mixinTable],
  data() {
    return {
      maxHeight:0,
      userId: getStorage("userId"),
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      visible: false,
      labelStyle: { width: "100px" },
      info: {
        is_sorter: "", // 该供应商是否支持代分拣 1：是，2否
        bills: [],
        order: {},
      },
      tableData: [],
      table: {
        total: 0,
      },

      loading: false,
      form: {
        loading: false,
        data: {
          goods_name: "",
          address_id: "",
        },
      },
      multipleSelection: [],
      currRow: {},
      storeArr: [],

      pos: 0,
      spanArr: [], // 合并单元格
      dialogTableVisible: false,
      refundInfo: {},
      //打印数据
      multipleSelectionDetails: [], // 打印数据
      batchPrintData: [],
      is_batch: false,
      dialogVisiblePrint: false,
      codeTextUrl: "",
      myUUID: "", // 存放生成的UUID值
      myPrintBatchDetails: {
        id: "myPrintBatchDetails",
        preview: false, // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
      },
      canPrint: false, //能打印的标识
      showUploadBill:false, //是否显示上传单据按钮

      dialogVisibleBill:false, //是否显示上传单据弹窗
      dialogImageUrl: '', 
      dialogVisibleUrl: false,
      imgFileList:[],
      fileList:[],
      formBill: {
          loading: false,
          data: {
            bind_id: '',// 供应商/采购员
            bills:'', //单据
          },
          rules:{
            type: [{ required: true, message:'请选择', trigger: 'change'}],
            bind_id: [{ required: true, message:'请选择', trigger: 'change'}],
            bills: [{ required: true, message:'请上传', trigger: 'change'}],
          }
        },
      showDeleteBill:false, //是否显示删除单据按钮
      billArr:[],
    };
  },
  created() {
    if (window.location.href.indexOf(".cuntoubao.test") != "-1") {
      this.codeTextUrl = "http://h5delivery.cuntoubao.test/#/pages/index/rk"; // 测式服地址
    } else {
      this.codeTextUrl = "http://h5delivery.cuntoubao.cn/#/pages/index/rk"; // 正式服地址
    };
    // this.$nextTick(() => {
    //   this.maxHeight = this.$refs.multipleTable.offsetHeight || 500;
    //   this.$refs.multipleTable.doLayout();
    // });
  },
  methods: {
    getDetail(row) {
      this.currRow = row;
      this.canPrint = row.canPrint;
      this.showUploadBill = row.showUploadBill;
      this.showDeleteBill = row.showDeleteBill;
      console.log(this.currRow.showType);
      this.getTable();
      this.getBills();
    },
    getBills() {
        let params = {
          id: this.currRow.id,
        };
        this.$http.get('/admin/purchase_order/getBill', { params: params}).then(res =>{
          if(res.code == 1) {
            this.billArr = res.data.list;
          }
        })
    },
    deleteBillRow(item,imgIndex) {
        let list = JSON.parse(JSON.stringify(item.bills))
        list.splice(imgIndex, 1)  // 删除指定位置的图片，list 变为剩余数据
        let params = {
          id: item.id,
          bills: list.length ? list.join('|') : ''
        };
        this.$http.post('/admin/purchase_order/updateBill', params).then(res =>{
          if(res.code ==1) {
            this.getBills();
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }
        })
    },
    getTable() {
      let _params = {
        id: this.currRow.id,
        goods_name: this.form.data.goods_name,
        address_id: this.form.data.address_id,
        page: 1,
        count: 1000,
      };
      this.$http
        .get("/admin/purchase_order/info", { params: _params })
        .then((res) => {
          if (res.code == 1) {
            this.info = res.data.main;
            // this.tableData = res.data.details.list; // 商品信息
            let tableList_ = [];
            res.data.details.forEach(item =>{
              item.list.forEach(i =>{
                i.accept_type = item.accept_type;
                i.norm_name = item.norm_name;
                i.accept_num = item.accept_num;
                i.accept_unit = item.accept_unit;
                i.accept_cov_times = item.accept_cov_times;
                i.accept_cov_unit = item.accept_cov_unit;
                i.accept_cov_num = item.accept_cov_num;
              })
              tableList_ = tableList_.concat(item.list);
            })
            
            this.tableData = tableList_.map((v) => {
              return {
                extent_curr:
                  Math.round(
                    v.last_purchase_price * 100 - v.old_purchase_price * 100
                  ) / 100, // 计算采购价上升或下降
                isEdit: false, // 全部收货编辑的时候用
                ...v,
              };
            });

            // 支持分拣供应商且来源为销售订单的商品去重
            if (this.info.is_sorter == 1 && this.info.source == 1) {
              let some = [];
              this.tableData.forEach((el) => {
                if (
                  !some.some(
                    (e) => e.code == el.code && e.spec_name == el.spec_name
                  )
                ) {
                  some.push(el);
                }
              });
              this.table.total = some.length;
            } else {
              this.table.total = res.data.details.total;
            }

            this.pos = 0; // 初始化合并单元格数据
            this.spanArr = []; // 初始化合并单元格数据
            this.getSpanArr(this.tableData);
            this.$nextTick(() => {
              // 替换文本把食堂换成用户
              this.replaceTextInElement(this.$el, "食堂", "用户");
            });
          }
        });
    },
    reset(done) {
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    // 获取食堂
    getStore() {
      this.$http
        .get("/admin/path/storeList", { params: { page: 1, count: 10000 } })
        .then((res) => {
          if (res.code === 1) {
            this.storeArr = res.data.list;
          }
        });
    },
    // 关闭
    handleCancel() {
      this.setConfirm(
        `确认关闭操作？`,
        { id: this.currRow.id },
        "/admin/purchase_order/cancel"
      );
    },
    // 导出
    plexportDataGoods() {
      let url = "/admin/purchase_order/download";
      let str = "";
      let obj = {
        id: this.currRow.id,
      };
      Object.keys(obj).forEach((item) => {
        str += `&${item}=${obj[item]}`;
      });
      window.open(
        `${process.env.VUE_APP_BASE_API}${url}?token=${this.token}${str}`
      );
    },
    // 收货
    handleReceive() {
      this.toggle(false);
      this.$parent.showReceive(this.currRow); // 调用父组件收货方法
    },
    // 复制
    handleCopy() {
      this.toggle(false);
      this.$parent.showAdd(this.currRow); // 调用父组件编辑方法
    },
    // 返回
    handleReturn() {
      this.form.data.goods_name = "";
      this.$emit("refresh");
      this.toggle(false);
      this.tableData = [];
    },
    handleRefund(row) {
      this.refundInfo = row;
      this.dialogTableVisible = true;
    },
    getSpanArr(data) {
      // data 是我们从后台拿到的数据
      for (var i = 0; i < data.length; i++) {
        if (i == 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同 (商品编码和规格一至的需要合并)
          if (
            data[i].code == data[i - 1].code &&
            data[i].spec_name == data[i - 1].spec_name
          ) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
    },
    // 当前行row、当前列column、当前行号rowIndex、当前列号columnIndex四个属性
    objectSpanMethod2({ row, column, rowIndex, columnIndex }) {
      let {property=''} = column;
      const weiyi = row.norm_name+row.unit_name+row.uni_spec;
      if (['norm_name','order_cate_name','accept_type','accept_num'].includes(property)) {
        if (rowIndex > 0 && row.norm_name === this.tableData[rowIndex - 1].norm_name && row.unit_name === this.tableData[rowIndex - 1].unit_name && row.uni_spec === this.tableData[rowIndex - 1].uni_spec) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        } else {
          const rows = this.tableDataColumn[weiyi];
          const length = rows.length;
          return {
            rowspan: length,
            colspan: 1,
          };
        }
      }
    }, 
    confirm(row, index) {
      console.log(row.isEdit, "row.isEdit");
      if (row.isEdit == false) {
        console.log("1111");
        let _currRow = { ...row, isEdit: true };
        this.$set(this.tableData, index, { ..._currRow });
      } else {
        console.log("2222");
        let _currRow = { ...row, isEdit: false };
        this.$set(this.tableData, index, { ..._currRow });
        let _params = {
          detail_id: row.id, // 明细id
          purchase_price: row.last_purchase_price, //采购单价
          delivery_money: row.delivery_money, //记账金额
          delivery_num: row.delivery_num, //记账数量
        };
        this.$http
          .post("/admin/purchase_order/updateDetail", _params)
          .then((res) => {
            if (res.code == 1) {
              this.$message.success("操作成功！");
              this.getTable();
            }
          });
      }
    },
    // 计算价格
    countPrice(row, index) {
      const reg = /^[\d]+$/;
      // 任何单位的数量都可以输入一位小数
      if (row.delivery_num && !reg.test(row.delivery_num)) {
        row.delivery_num = row.delivery_num = row.delivery_num.match(
          /\d+(\.\d{0,2})?/
        )
          ? row.delivery_num.match(/\d+(\.\d{0,2})?/)[0]
          : "";
      }

      // 采购价格只允许输入两位小数
      if (row.last_purchase_price && !reg.test(row.last_purchase_price)) {
        row.last_purchase_price = row.last_purchase_price.match(
          /\d+(\.\d{0,2})?/
        )
          ? row.last_purchase_price.match(/\d+(\.\d{0,2})?/)[0]
          : "";
      }
      // 计算本次收货价格 = （采购价 * 记账数量）
      if (!!row.last_purchase_price && !!row.delivery_num) {
        row.delivery_money =
          Math.round(
            parseFloat(
              (row.cov_times == 0
                ? row.last_purchase_price
                : row.last_purchase_price / row.cov_times) * row.delivery_num
            ) * 100
          ) / 100;
        this.$set(this.tableData, index, row);
      }
    },
    handleClosePrint() {
      this.batchPrintData = [];
      this.is_batch = false; //是否批量打印
      this.dialogVisiblePrint = false;
    },
    handleSelectionChangeDetails(val) {
      this.multipleSelectionDetails = val;
    },
    handlePrint(row) {
      this.batchPrintData = [row]; // 单条打印
      this.dialogVisiblePrint = true;
      this.is_batch = false;
    },
    batchPrint() {
      if (this.multipleSelectionDetails.length) {
        this.batchPrintData = this.multipleSelectionDetails;
        this.is_batch = true; //是否批量打印
        this.dialogVisiblePrint = true;
      } else {
        this.$message.warning("至少勾选一条数据");
      }
    },
    handlePrintbatchFun() {
      this.dialogVisiblePrint = false;
      console.log(this.batchPrintData, "batchPrintData");
      this.batchPrintData.forEach((v, i) => {
        this.currPrintObj = v;
        this.myUUID = uuid().replace(/-/g, "/"); // myUUID将字符串中的 '-' 替换成 '/'
        this.$refs["qrCodeUreBatchDetails"][i].innerHTML = ""; //生成二维码之前先清除上一次的
        console.log(`${this.codeTextUrl}?detail_id=${v.id}`);
        new QRCode(this.$refs.qrCodeUreBatchDetails[i], {
          text: `${this.codeTextUrl}?detail_id=${v.id}`,
          width: 100,
          height: 100,
          colorDark: "#000",
          colorLight: "#fff",
          correctLevel: QRCode.CorrectLevel.M,
        });
      });
      this.myPrintBatchDetails = {
        id: "myPrintBatchDetails",
        popTitle: "打印", // 打印配置页上方标题
        extraHead: "", //最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
        preview: true, // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
      };
    },
    getdelivery_num(item) {
      if (Number(item.delivery_num)) {
        return Number(item.delivery_num);
      } else if (!Number(item.delivery_num) && item.status == 1) {
        return "";
      } else {
        item.delivery_num;
      }
    },
    handleClose() {
      this.dialogVisibleBill = false;
      this.fileList = [];
    },
    handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisibleUrl = true;
    },
    // 图片上传成功
      handleAvatarSuccess(res, file) {
        this.formBill.data.bills = res.data.all_path_url;
        let strImg = {
          url: res.data.all_path_url,
          name: ''
        }
        this.fileList.push(strImg)
        this.$refs.elFormDomBill.clearValidate();
      },
      // 图片上传之前
      beforeAvatarUpload(file) {
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
          this.$message.warning('图片尺寸超出5M，请修改');
        }
        return isLt5M;
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制最多只能选择 10 个文件`);
      },
      handleRemove2(file, fileList) {
        let _fileList = this.$refs.upload.uploadFiles;
        if(this.imgFileList.length > 0) {
         let index = this.imgFileList.findIndex(v => v.uid == file.uid)
         if(index > -1) {
          this.imgFileList.splice(index, 1) 
         }
        }
      },
      uploadFile(file) {
        this.imgFileList.push(file.file);
      },
      handleBill() {
        this.dialogVisibleBill = true;
        this.formBill.data.bind_id = '';
        this.fileList = [];
      },
      // 上传单据
      async sumbitBill() {
        // this.$refs.upload.submit();
        if(this.imgFileList.length < 1) {
          return this.$message.warning('请上传单据')
        }
        var formData = new FormData();
        this.imgFileList.forEach(v => {
          formData.append('file[]',v)
        })
        this.formBill.loading = true;
        await this.$http.post('/common/qiniu/upload_multiple', {formData, type:'upload'}).then(res => {
          if(res.code == 1) {
            console.log(res.data.path);
            this.fileList = res.data;
          }else {
            this.formBill.loading = false;
          }
        }).finally(() => {
          this.formBill.loading = false;
        })
        let _params = {
          id: this.currRow.id,
          bind_id: this.info.supplier_id, // 供应商/采购员
          bills: this.fileList.map(v => v.all_path_url).join("|")
        }
        console.log(_params)
        this.$http.post('/admin/purchase_order/uploadBill', _params).then(res => {
          if(res.code == 1) {
            this.dialogVisibleBill = false;
            this.getBills();
            this.$message.success("上传成功！")
            this.imgFileList = [];
            this.fileList = [];
            this.getTable(); // 自动刷新列表接口
          }
        }).finally(() => {
          this.formBill.loading = false;
        })
       
      },
      editReceive(row,index) {
        let {lock_amount= ' '} = row;
        row.last_purchase_price = lock_amount
        this.countPrice(row, index);
      }
  },
  computed:{
      tableDataColumn() {
      const obj = {};
      this.tableData.forEach((v, i) => {
        // const norm_name = v.norm_name;
        const weiyi = v.norm_name+v.unit_name+v.uni_spec;
        if (obj[weiyi]) {
          obj[weiyi].push(i);
        } else {
          obj[weiyi] = [];
          obj[weiyi].push(i);
        }
      });
      return obj;
    },             
    }
};
</script>
<style media="print" lang="scss">
.printContent {
  display: none;
}
.print-text {
  margin: 0 0.3125rem;
}

@page {
  size: auto;
  // margin: 0 2mm;
}
@media print {
  html {
    background-color: #ffffff;
    height: auto;
    margin: 0;
  }
  body {
    border: solid 0.0625rem #ffffff;
    font-size: 0.625rem;
  }
  body, html, div {
    height: auto !important; /* 确保内容高度自动调整 */
    width: auto !important; /* 确保内容宽度自动调整 */
    page-break-inside: avoid; /* 避免内容被分页拆分 */
  }
  .print-title {
    margin: 0 0.3125rem;
    border-bottom: 0.0625rem solid #000;
    font-size: 1.6rem;
    margin-top: 0.2rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .print-con {
    font-size: 1rem;
  }
  .print-con2 {
    font-size: 0.5rem;
  }
  .print-text {
    font-size: 0.5rem;
  }
  .layout__wrap {
    height: auto !important;
  }
  .main-view {
    height: auto !important;
  }
  .print-flex {
    display: flex;
    justify-content: space-between;
    margin: 0.3125rem;
  }
  .print-flex-main {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .printContent {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0.3125rem;
    margin: 0;
  }
}
</style>

<style scoped lang="scss">
.addPerson__wrap {
  @include position($t: 0, $r: 0, $b: 0, $l: 0);
}
.addPerson__wrap .main {
  overflow-x: hidden;
  background: #fff;
}
.returnBtn {
  z-index: 99;
  box-shadow: 0 0 8px 0 rgb(232 237 250 / 60%),
    0 2px 4px 0 rgb(232 237 250 / 50%);
}
.footerWrap {
  text-align: center;
  padding: 10px;
  box-shadow: 0 0 8px 0 rgb(232 237 250 / 60%),
    0 2px 4px 0 rgb(232 237 250 / 50%);
  z-index: 99;
}
.itemTime {
  display: block;
  margin-bottom: 10px;
  height: 30px;
  line-height: 30px;
}
.itemTime::before {
  content: "";
  width: 5px;
  height: 15px;
  background: #2cb167;
  border-radius: 6px;
  display: inline-block;
  margin-right: 10px;
  position: relative;
  top: 2px;
}
.flex {
  display: flex;
}
.mt20 {
  margin-top: 20px;
}
.mb20 {
  margin-bottom: 20px;
}
.width200px {
  width: 200px;
}
.after-table {
  padding: 10px;
  font-size: 13px;
  color: #303030;
  text-align: right;
}

::v-deep .el-table tbody tr:hover > td {
  background-color: #fff !important;
}
.el-table tbody tr:hover > td {
  background-color: #fff !important;
}
</style>
